import axios from 'axios';
import RestService from '../../helpers/RestService';
import { ajaxUrls } from '../../settings/routes';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export async function getQuestions() {
  try {
    const {data} = await axios.get('/api/question-import/get');

    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}

export async function deleteQuestions(ids) {
  try {
    const {data} = await axios.post('/api/question-import/delete', {ids: JSON.stringify(ids)});

    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}

export async function importQuestions(body) {
  try {
    const {data} = await axios.post('/api/question-import/import', {...body,ids: JSON.stringify(body.ids)});

    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionImport/actions.js